import { reactive } from 'vue';

const state = reactive({
  notifications: [],
});

let nextId = 0;

export function useNotify() {
  function notify(message, type = 'success', duration = 4000) {
    const id = nextId++;
    state.notifications.push({ id, message, type });
    setTimeout(() => {
      const idx = state.notifications.findIndex(n => n.id === id);
      if (idx > -1) state.notifications.splice(idx, 1);
    }, duration);
  }

  function success(msg) { notify(msg, 'success'); }
  function error(msg) { notify(msg, 'danger', 5000); }
  function warning(msg) { notify(msg, 'warning', 5000); }
  function info(msg) { notify(msg, 'info'); }

  return { notifications: state.notifications, notify, success, error, warning, info };
}
